import ApiService from '@/services/api.service';

const state = {
  isLoading: false,
  error: null,
  sales: {
    data: [],
    meta: {
      page: {},
    },
  },
  sale: {},
};

const getters = {
  getLoading: (state) => {
    return state.isLoading;
  },
  getSales: (state) => {
    return state.sales;
  },
  getSale: (state) => {
    return state.sale;
  },
  getError: (state) => {
    return state.error;
  },
};

const mutations = {
  setLoader: (state, status) => (state.isLoading = status),
  setSales: (state, data) => (state.sales = data),
  setSale: (state, data) => (state.sale = data),
  setError: (state, data) => (state.error = data),
};

const actions = {
  async fetchSales(
    { commit },
    { keyword, pageNumber, pageSize, search, is_completed }
  ) {
    commit('setLoader', true);
    const params = {};
    let page = [];
    let filter = [];
    filter['order_type'] = 'sale';
    if (pageNumber && pageNumber !== '') page['number'] = pageNumber;
    if (pageSize) page['size'] = pageSize;
    if (keyword && keyword !== '') filter['code'] = keyword;
    if (search && search !== '') filter['search'] = search;
    if (is_completed !== undefined) filter['is_completed'] = is_completed;

    Object.keys(page).map((item) => {
      const key = `page[${item}]`;
      Object.assign(params, { [key]: page[item] });
    });
    Object.keys(filter).map((item) => {
      const key = `filter[${item}]`;
      Object.assign(params, { [key]: filter[item] });
    });
    Object.assign(params, {
      include: 'area,buyer-type,destination-office,order-details,origin-office',
    });
    Object.assign(params, { sort: '-createdAt' });
    try {
      let response = await ApiService.get('/api/v1/orders', {
        params,
      });
      commit('setSales', response.data);
      commit('setError', null);
      return response;
    } catch (error) {
      commit('setError', error.response.data.errors);
      commit('setSales', {
        data: [],
        meta: { page: {} },
      });
    }
    commit('setLoader', false);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
